export const HTTP_CODE_SUCCESS = 200 as const;
export const HTTP_CODE_REACHED_SESSIONS_LIMIT = 203 as const;
export const HTTP_CODE_BAD_REQUEST = 400 as const;
export const HTTP_CODE_UNAUTHORIZED = 401 as const;
export const HTTP_CODE_PAYMENT_REQUIRED = 402 as const;
export const HTTP_CODE_NOT_FOUND = 404 as const;
export const HTTP_CODE_LOGIN_ALREADY_EXISTENT = 409 as const;
